import React from "react";
import get from "lodash/get";
import SectionBezel from "components/SectionBezel";
import Pill from "components/Pill";
import { interpolateRoute } from "utils/route";
import PATHS from "utils/paths";
import { useCtxReferences } from "utils/selectors";
import { HUB_APP_SUB_SECTION } from "utils/constants/navigation";
import { SETTINGS_TABS } from "utils/constants/settings";
import { STATE_KEYS } from "utils/constants/state";
import Link from "next/link";
import ZoneLink from "components/ZoneLink";
import { DOCS_ZONE_LINK } from "constants/docs";
import { SLIM_PILL_CLASSES, STATUS, UI_THEME } from "utils/constants/ui";
import ExternalLink from "components/ExternalLink";
import classnames from "classnames";

const Hosting = () => {
  const { application } = useCtxReferences();
  const allowedDomains =
    get(application, STATE_KEYS.APPLICATION.ALLOWLIST_DOMAINS) || [];
  const appSettingsRoute = `${interpolateRoute(PATHS.HUB_APPLICATIONS_SHOW, {
    application
  })}/${HUB_APP_SUB_SECTION.SETTINGS}?tab=${SETTINGS_TABS.APPLICATION}`;
  const domainsCount = allowedDomains.length;
  let actionNode;
  if (!domainsCount) {
    actionNode = (
      <Pill
        theme={UI_THEME}
        status={STATUS.WARNING}
        copy="Domain required"
        customClasses={SLIM_PILL_CLASSES}
      />
    );
  }
  const label = domainsCount ? "Allowed domains" : "Missing allowed domains";

  return (
    <SectionBezel header="Hosting" expandable action={actionNode}>
      <div className="flex flex-column w-100">
        <div className="flex flex-column">
          <label className="f5 fw6 db">{label}</label>
          <div className="pt2">
            {domainsCount ? (
              <div className="w-100">
                <div className="f6 lh-copy">
                  Each of your allowed domains can host an embed. To add more,
                  update your set of allowed domains{" "}
                  <Link href={appSettingsRoute}>
                    <span className="fw6 link__decoration--hover color-primary pointer">
                      here.
                    </span>
                  </Link>
                </div>
              </div>
            ) : (
              <div className="f6 ba br2 hairline-1 lh-copy pa2 bg-content--secondary">
                <div className="f6">
                  Add the domain of where your embed will be hosted to your
                  application's set of allowed domains. Once added, your embed
                  will be able to load within your host site.
                </div>
                <div className="f6">
                  This is a security measure to prevent your embed from being
                  hosted on an unauthorized domain. You can update your set of
                  allowed domains{" "}
                  <Link href={appSettingsRoute}>
                    <span className="fw6 link__decoration--hover color-primary pointer">
                      here.
                    </span>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
        {allowedDomains.length > 0 ? (
          <div className="pt2">
            <ul className="ma0 pa2 hairline-1 ba br2 hairline-1 list">
              {allowedDomains.map((domain, domainIx) => {
                return (
                  <li
                    className={classnames("w-100 ph1", {
                      pt2: domainIx
                    })}
                    key={domainIx}
                  >
                    <ExternalLink
                      href={domain}
                      copy={domain}
                      hideIcon
                      customClasses={{
                        container: "",
                        link:
                          "link link__decoration--hover color-primary pointer",
                        copy: "f5 fw5"
                      }}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        ) : null}
        {/* Fix link */}
        <div className="pt2">
          <ZoneLink
            href={DOCS_ZONE_LINK.LEARN_PAYMENT_LINKS_OVERVIEW}
            zone
            linkProps={{
              className: "link",
              target: "_blank"
            }}
          >
            <div className="f6 fw6 link__decoration--hover color-primary pointer">
              Learn more
            </div>
          </ZoneLink>
        </div>
      </div>
    </SectionBezel>
  );
};
export default Hosting;
